import React, { useRef, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationRootState } from '../../../../types';
import { FiMoreVertical } from 'react-icons/fi';
import { setColorsPanelAction } from '../../../Configurator/actions/general';
import { ActivePanel } from '../../../Configurator/constants/general';
import useOnClickOutside from 'use-onclickoutside';
import { useTranslation } from 'react-i18next';
import Img from '../../../../components/Img';
import F1Img from 'assets/images/cross_pieces/F1.png';
import RodOption from './RodOption';

interface StateProps {}

const stateSelector = createStructuredSelector<
  ApplicationRootState,
  StateProps
>({});

const ShelvesOptions = () => {
  const [isOpen, setOpen] = useState(false);
  const dispatch = useDispatch();
  const {} = useSelector(stateSelector);
  const { t } = useTranslation();
  const ref = useRef(null);
  useOnClickOutside(ref, () => {
    setOpen(false);
  });

  const hide = () => {
    setOpen(false);
  };

  return (
    <div className="relative text-main">
      <button
        onClick={() => {
          setOpen(!isOpen);
        }}
        className="mx-2"
      >
        <FiMoreVertical className="h-5 w-5" />
      </button>
      {isOpen && (
        <ul
          ref={ref}
          className="position right-0 top-0 -mt-6 absolute bg-white border border-gray-400 w-56 z-100"
        >
          <li className="flex justify-center text-lg italic font-light border-b border-gray-200">
            {t('Shelves options')}
          </li>
          <li className="">
            <button
              onClick={() => {
                dispatch(setColorsPanelAction(ActivePanel.crossPieces));
                setOpen(false);
              }}
              className="flex items-center px-3 py-2 hover:bg-gray-200 w-full"
            >
              <Img src={F1Img} alt="doors" className="h-8 w-8" />
              <div className="ml-4">
                {t('Switch to')} {t('crossPieces')}
              </div>
            </button>
          </li>
          <li className="">
            <RodOption afterAction={hide} />
          </li>
        </ul>
      )}
    </div>
  );
};

export default ShelvesOptions;
